import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'

export default function PersonalNotificationSituationSelect({
  ...props
}: SelectProps) {
  const { t } = useTranslation()

  return (
    <Select allowClear {...props}>
      <Select.Option value={0}>充電結束</Select.Option>
    </Select>
  )
}
